package org.example.project.model

enum class AttackType(
    val displayName: String,
    val description: String,
    val maxCharges: Int
) {
    TORPEDO(
        displayName = "Torpedo",
        description = "Single-cell precision strike",
        maxCharges = -1
    ),
    CROSS_FIRE(
        displayName = "Cross Fire",
        description = "Hits target + 4 adjacent cells",
        maxCharges = 2
    ),
    CLUSTER_BOMB(
        displayName = "Cluster Bomb",
        description = "2×2 area bombardment",
        maxCharges = 1
    ),
    LINE_STRIKE(
        displayName = "Line Strike",
        description = "Entire row or column",
        maxCharges = 1
    ),
    SONAR(
        displayName = "Sonar Ping",
        description = "Reveals 3×3 area without damage",
        maxCharges = 2
    )
}
